import i18next from "i18next";
import { commonsStore, valid } from "lego-gui-lib";
import split from "lodash/split";
import { OutputType } from "../treeBlockOutputsDataSource";
import { LocalOutput } from "../schema";
import * as Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

export const NumericCodeMinDigitsToCollectValidator = valid(
  (v: any, values: any, meta: any) =>
    values.maxDigitsToCollect ? v <= values.maxDigitsToCollect : true,
  "hns:tree.treeBlock.numericCodeParams.minDigitsToCollectValidator",
  '"Min" must be lower or equal "Max"'
);

export const TimeOfDayValidator = (
  output: LocalOutput,
  outputOptions: LocalOutput[]
): boolean => {
  for (const o of outputOptions) {
    if (o.type !== OutputType.DEFAULT) {
      if (checkTimePeriodsOverlap(output.value, o.value)) {
        showErrorMessage(
          "hns:tree:treeBlock:output:timeOfDay:timePeriodsOverlap"
        );
        return false;
      }
    }
  }
  return true;
};

export const TrafficDistributionValidator = (
  output: LocalOutput,
  outputOptions: LocalOutput[]
): boolean => {
  let sum = 0;
  outputOptions.forEach((o: LocalOutput) => {
    if (o.type !== OutputType.DEFAULT) {
      sum += parseInt(o.value);
    }
  });
  const sumWithUserOutput = sum + parseInt(output.value);
  if (sumWithUserOutput < 0 || sumWithUserOutput > 100) {
    showErrorMessage(
      "hns:tree:treeBlock:output:trafficDistribution:hundredPercentExceeded"
    );
    return false;
  }
  return true;
};

export const NumericRangeValidator = (
  output: LocalOutput,
  outputOptions: LocalOutput[]
): boolean => {
  for (const o of outputOptions) {
    if (o.type !== OutputType.DEFAULT) {
      if (checkNumericRangeOverlap(output.value, o.value)) {
        showErrorMessage(
          "hns:tree:treeBlock:output:numericCode:numericRangeOverlap"
        );
        return false;
      }
    }
  }
  return true;
};

const checkTimePeriodsOverlap = (
  userOutput: string,
  outputOption: string
): boolean => {
  const IRRELEVANT_MONTH_DAY_YEAR = "December 17, 1995";
  const [from, to] = split(userOutput, "-");
  const [from2, to2] = split(outputOption, "-");
  const fromDate = new Date(`${IRRELEVANT_MONTH_DAY_YEAR} ${from}:00`);
  const toDate = new Date(`${IRRELEVANT_MONTH_DAY_YEAR} ${to}:00`);
  const fromDate2 = new Date(`${IRRELEVANT_MONTH_DAY_YEAR} ${from2}:00`);
  const toDate2 = new Date(`${IRRELEVANT_MONTH_DAY_YEAR} ${to2}:00`);
  const range = moment.range(fromDate, toDate);
  const range2 = moment.range(fromDate2, toDate2);
  return range.overlaps(range2, { adjacent: true });
};

const checkNumericRangeOverlap = (
  userOutput: string,
  outputOption: string
): boolean => {
  const [from, to] = split(userOutput, "-");
  const [from2, to2] = split(outputOption, "-");
  return parseInt(from) <= parseInt(to2) && parseInt(from2) <= parseInt(to);
};

export const showErrorMessage = (translationKey: string) =>
  commonsStore.newError({
    name: "",
    message: i18next.t(translationKey),
    errors: []
  });
